var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        !_vm.isRevision
          ? _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row form-campaign" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" }, [
                  _c("div", { staticClass: "profile-data" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Nome do Produto")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.name,
                              expression: "name"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "fullname",
                            placeholder: "Informe o nome do produto"
                          },
                          domProps: { value: _vm.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.name = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Descrição do Produto")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.description,
                              expression: "description"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "fullname",
                            placeholder: "Informe a descrição do produto"
                          },
                          domProps: { value: _vm.description },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.description = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Url da Loja/Produto")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.url,
                              expression: "url"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "url",
                            placeholder: "Informe a url da loja ou do produto"
                          },
                          domProps: { value: _vm.url },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.url = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Preço Regular")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "money",
                              rawName: "v-money",
                              value: _vm.money,
                              expression: "money"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.price,
                              expression: "price"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "fullname",
                            placeholder: "Defina o valor regular do produto"
                          },
                          domProps: { value: _vm.price },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.price = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Desconto (%)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value,
                              expression: "value"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "fullname",
                            placeholder: "Informe o valor de desconto em %"
                          },
                          domProps: { value: _vm.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.value = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Prazo da Campanha")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.endDate,
                              expression: "endDate"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "enddate",
                            placeholder: "Informe a data limite da campanha"
                          },
                          domProps: { value: _vm.endDate },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.endDate = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Cupom")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.code,
                              expression: "code"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "code",
                            placeholder: "Insira o código do cupom de desconto"
                          },
                          domProps: { value: _vm.code },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.code = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("ONG Beneficiada")]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.project,
                                expression: "project"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { name: "project" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.project = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Selecione...")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.projects, function(p) {
                              return _c(
                                "option",
                                {
                                  key: p.ProjectId,
                                  domProps: { value: p.ProjectId }
                                },
                                [_vm._v(_vm._s(p.Info.title))]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _vm.showMsg
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "alert alert-danger alert-dismissible fade show",
                                attrs: { role: "alert" }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.msg) +
                                    "\n                  "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "close",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "alert",
                                      "aria-label": "Fechar"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.hideMessage()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("×")]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn submit",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.revision()
                            }
                          }
                        },
                        [_vm._v("Revisar Campanha")]
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isRevision
          ? _c("div", { staticClass: "container revision" }, [
              _c("div", { staticClass: "row form-campaign" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" }, [
                  _c("div", { staticClass: "profile-data" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Nome do Produto:")]),
                        _vm._v(" "),
                        _c("h4", [_vm._v(_vm._s(_vm.name))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Descrição do Produto:")]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.url))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Url da Loja ou Produto:")]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.description))])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.price && _vm.price != ""
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "form-group col-sm" }, [
                            _c("label", [_vm._v("Preço Regular")]),
                            _vm._v(" "),
                            _c("h5", [_vm._v(_vm._s(_vm.price))])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.value && _vm.value != ""
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "form-group col-sm" }, [
                            _c("label", [_vm._v("Desconto")]),
                            _vm._v(" "),
                            _c("h5", [_vm._v(_vm._s(_vm.value) + " %")])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Prazo da Campanha")]),
                        _vm._v(" "),
                        _c("h5", [_vm._v(_vm._s(_vm.endDate))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group col-sm" }, [
                        _c("label", [_vm._v("Cupom")]),
                        _vm._v(" "),
                        _c("h4", [_vm._v(_vm._s(_vm.code))])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.project
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "form-group col-sm" }, [
                            _c("label", [_vm._v("ONG Beneficiada")]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(_vm._s(_vm.getProject(_vm.project)))
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger float-left",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.revision()
                            }
                          }
                        },
                        [_vm._v("Voltar")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn submit float-right",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.save()
                            }
                          }
                        },
                        [_vm._v("Publicar Campanha")]
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Crie a sua Campanha")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Informe os dados do produto que deseja divulgar. Essa campanha será exibida no Descontos do Bem e na página da ONG."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Revise a sua Campanha")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Confirme todos os dados antes de publicar a campanha. Após a publicação, a campanha não poderá mais ser editada."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27fa3b48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27fa3b48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCampaign.vue
// module id = null
// module chunks = 